export function isConsultant(user) {
  if(!user || !user.groups) {
    return false;
  }

  if(user.groups === 'BE_RBV_INT_CONSULTANT' || user.groups === 'BE_RBV_EXT_CONSULTANT') {
    return true;
  }

  if(Array.isArray(user.groups)) {
    if(user.groups.includes('BE_RBV_INT_CONSULTANT') || user.groups.includes('BE_RBV_EXT_CONSULTANT')) {
      return true
    }
  }

  return false;
}
